import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';

const Favicon = () => {
  const { site, allFile } = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          title
        }
      }
      allFile(filter: { name: { eq: "favicon" } }) {
        edges {
          node {
            publicURL
          }
        }
      }
    }
  `);

  const faviconUrl = allFile.edges[0]?.node.publicURL;

  return (
    <>
      <link rel="icon" href={faviconUrl} />
      <link rel="apple-touch-icon" href={faviconUrl} />
      <link rel="shortcut icon" href={faviconUrl} />
    </>
  );
};

export default Favicon;
